import Vue from "vue";
import Vuex from "vuex";
import VFormBase from "vuetify-form-base";
import VueFbCustomerChat from "vue-fb-customer-chat";

import * as VueGoogleMaps from "vue2-google-maps";

import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import titleMixin from "./mixins/titleMixin";
import BackButton from "./components/BackButton";
import ExtendButton from "./components/common/ExtendButton";

import { VCheckbox, VSelect, Touch } from "vuetify/lib";

import "./plugins/apexcharts";

Vue.config.productionTip = false;

Vue.component("v-checkbox", VCheckbox);
Vue.component("v-select", VSelect);
Vue.component("v-form-base", VFormBase);
Vue.component("back-button", BackButton);
Vue.component("extend-button", ExtendButton);

Vue.directive("touch", Touch);

Vue.use(Vuex);
Vue.mixin(titleMixin);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBwJQfxGdPZRHXLYcRolRmP9lNS5ZWVoE8",
    libraries: "places"
  }
});

Vue.use(VueFbCustomerChat, {
  page_id: "145410575521975",
  theme_color: "#1a73e8",
  locale: "th_TH",
  logged_in_greeting: "สวัสดีค่า ยินดีให้บริการค่ะ",
  logged_out_greeting: "สวัสดีค่า ยินดีให้บริการค่ะ"
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
